const Footer = () => {
  return (
    <footer className="footer">
      <ul className="social-links list-non-bullet">
        <li className="list-item-inline">
          <a className="link" href="https://www.linkedin.com/in/abhij1607/">
            <i className="fa fa-3x fa-linkedin" />
          </a>
        </li>
        <li className="list-item-inline">
          <a className="link" href="https://github.com/abhij1607">
            <i className="fa fa-3x fa-github" />
          </a>
        </li>
        <li className="list-item-inline">
          <a className="link" href="https://twitter.com/abhijain1607">
            <i className="fa fa-3x fa-twitter-square" />
          </a>
        </li>
      </ul>
    </footer>
  );
};
export { Footer };
